import { gql } from '@apollo/client';

export default gql`
  fragment analyticsFile on analytics_files {
    id
    integrations
    pipelineId
    updatedAt
    analytics_file_settings {
      id
      host
      cdnURL
      compressFile
      minifyFile
      botFilterEnabled
      matchIDConsentCode
      impliedConsent
      cookieName
      itpSettings
      fileHostingType
      analyticsFileId
      windowVariableName
      storagePrefix
      storageType
      storageDatabase
      consentSource
      optInValues
      globalPrivacyControl
    }
    google_tag_settings {
      id
      loadGtag
      loadWhenConsentDenied
      refreshOnEmptyHash
      vtcEnabled
      gtgEnabled
      gtgScriptSource
      egsm
      tagId
    }
    analytics_file_identity_syncs {
      id
      settings
      analyticsFileId
      identitySyncId
      consentCategoryId
      tcfEnabled
      settingsVersion
      enableResyncOnSettingsChange
      identity_sync {
        id
        name
        friendlyName
      }
    }
  }
`;
